import barba from '@barba/core'
import Emitter from './emitter'
import Viewport from '../stores/viewport.js'
import App from '../stores/app.js'
// import preloadImages from '../utilities/preloadImages.js'
import { gsap, Quart } from 'gsap'

let _previousHistoryLength = 0
let _scrollY = 0

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual'
}

// TODO: preload images
const preloadImages = function (dom, callback) {
  callback()
}

if (!/wp\-admin\//.test(window.location.pathname)) {
  barba.init({
    // debug: true,
    schema: {
      wrapper: 'app',
      container: 'page'
    },
    timeout: 30000,
    prefetchIgnore: false,
    transitions: [
      {
        name: 'default-transition',
        sync: true,
        leave(data) {
          App.lenis.stop()
          Emitter.emit('loader:show')
          Emitter.emit('transition:leave')

          const { scrollY, innerWidth, innerHeight } = window

          gsap.set(data.current.container, {
            position: 'fixed',
            zIndex: 1,
            top: -scrollY,
            left: 0,
            width: innerWidth,
            height: innerHeight,
            transformOrigin: `50% ${scrollY + innerHeight}px`,
            onComplete: () => {
              Emitter.emit('nav:close')
            }
          })

          window.scrollTo(0, 0)
        },
        enter(data) {
          try {
            Emitter.emit('transition-in:start')
            const goingBack = barba.history.h.length < _previousHistoryLength
            let y = goingBack ? _scrollY : 0
            _scrollY = barba.history.current.scroll.y
            _previousHistoryLength = barba.history.h.length

            const parser = new DOMParser()
            const dom = parser.parseFromString(data.next.html, 'text/html')

            updateHeader(dom)
            updateBodyClasses(data.next.html)

            preloadImages(dom, () => Emitter.emit('document:ready'))

            const { innerHeight } = window

            const transition = new Promise((resolve) => {
              gsap.set(data.next.container, {
                translateY: goingBack ? -y : 0,
                transformOrigin: `50% ${
                  goingBack ? innerHeight + y + 'px' : '100vh'
                }`
              })

              requestAnimationFrame(() => {
                gsap.to(data.current.container, {
                  duration: 0.8,
                  opacity: 0,
                  scale: 1.2,
                  ease: Quart.easeInOut
                })

                gsap.from(data.next.container, {
                  duration: 0.8,
                  opacity: 0,
                  scale: 0.8,
                  ease: Quart.easeInOut,
                  clearProps: 'all',
                  onComplete() {
                    App.lenis.start()
                    App.lenis.scrollTo(y, { immediate: true })
                    Emitter.emit('resize')
                    Emitter.emit('transition-in:done')
                    resolve()
                  }
                })
              })
            })

            return transition
          } catch (e) {
            console.error(e)
          }
        }
      },
      {
        name: 'case-transition',
        sync: true,
        from: {
          custom({ trigger }) {
            return trigger.dataset?.nextTransition
          }
        },
        to: {
          namespace: ['case-study']
        },
        leave(data) {
          App.lenis.stop()
          Emitter.emit('loader:show')
          Emitter.emit('transition:leave')

          const blocks = data.current.container.querySelectorAll(
            'block-case-study-header'
          )
          const footerBlock = Array.from(blocks).pop()
          data._blockPos = footerBlock.getBoundingClientRect().top
          data._currentTransform =
            footerBlock.querySelector('.js-background').style.transform

          gsap.set(data.current.container, {
            position: 'fixed',
            top: -window.scrollY,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight
          })
        },
        enter(data) {
          Emitter.emit('transition-in:start')

          const parser = new DOMParser()
          const dom = parser.parseFromString(data.next.html, 'text/html')

          updateHeader(dom)
          updateBodyClasses(data.next.html)

          window.scrollTo(0, 0)

          preloadImages(dom, () => Emitter.emit('document:ready'))

          const { _blockPos } = data
          data._blockPos = 0

          const nextBackground =
            data.next.container.querySelector('.js-background')
          nextBackground.style.opacity = ''
          nextBackground.style.transform = data._currentTransform

          gsap.from(data.next.container, {
            opacity: 0,
            duration: 0.2
          })

          gsap.to(data.current.container, {
            duration: 0.8,
            delay: 0.2,
            opacity: 0,
            translateY: -_blockPos,
            ease: Quart.easeInOut
          })

          return gsap.from(data.next.container, {
            duration: 0.8,
            delay: 0.2,
            translateY: _blockPos,
            ease: Quart.easeInOut,
            onComplete() {
              App.lenis.start()
              Emitter.emit('transition-in:done')
            }
          })
        }
      }
    ]
  })

  barba.hooks.before(() => {})

  barba.hooks.after(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: {
          path: window.location.pathname,
          title: document.title
        }
      })
    }
  })

  function updateBodyClasses(htmlString) {
    let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
      match = regexp.exec(htmlString)
    if (!match || !match[1]) {
      // If no body class, remove it
      document.body.setAttribute('class', '')
    } else {
      // Set the new body class
      document.body.setAttribute('class', match[1])
    }
  }

  function updateHeader(dom) {
    const nextHeaderLinks = Array.from(dom.querySelectorAll('.js-header-link'))
    const nextCurrentMenu = dom.querySelector('.js-header-nav-current').dataset
      .current
    let headerLinkActive = []

    nextHeaderLinks.forEach((item, i) => {
      if (item.classList.contains('is-active')) {
        headerLinkActive.push(i)
      }
    })

    const headerLinks = Array.from(document.querySelectorAll('.js-header-link'))

    headerLinks.forEach((item, i) => {
      item.classList.remove('is-active')

      if (headerLinkActive.includes(i)) {
        item.classList.add('is-active')
      }
    })

    Emitter.emit('header-nav:update', { nextCurrentMenu, headerLinkActive })
  }
}
